var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',_vm._g(_vm._b({attrs:{"label":_vm.$t('core.routing_key'),"items":_vm.items,"item-value":"value","item-text":"text","prepend-inner-icon":_vm.routingkey == 'quarantine' ? 'mdi-alert' : ''}},'v-select',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }